import { H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import { Persona } from "../../types"
import { useNavigate } from "react-router-dom"
import { Formik } from "formik"
import { Container } from "react-bootstrap"
import BottomFormFixed from "../../components/BottomFormFixed"
import { initialValuesPersona, validationSchemaPersona } from "./PersonaCommon"
import { usePersonaCreate } from "../../hooks/persone"
import PersonaForm from "./PersonaForm"
import { useMemo } from "react"
import { ScrollLayout } from "../../components/ScrollLayout"
import { transformErrorForForm } from "../../utils/utils"

export default function PersonaCreate() {
  const createPersona = usePersonaCreate()
  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Persone", href: "/opere/persone" }, { label: "Creazione Persona" }])

  const initialValues = useMemo(() => initialValuesPersona(), [])
  const validationSchema = useMemo(() => validationSchemaPersona(), [])

  return (
    <Layout>
      <ScrollLayout hasBottomFixed>
        <H1>Nuova persona</H1>
        <ScrollLayout.Scroll>
          <Formik
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              return createPersona.mutateAsync(values as Persona).then((persona) => {
                navigate(`/opere/persone`)
              }).catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
            }}
          >
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Container fluid className="mt-6" style={{ marginBottom: "100px" }}>
                  <PersonaForm />
                </Container>
                <BottomFormFixed url="/opere/persone" />
              </form>
            )}
          </Formik>
        </ScrollLayout.Scroll>
      </ScrollLayout>
    </Layout>
  )
}
